
import Vue from "vue";
import { appConfig } from "./utils.js";
const api = appConfig.api_path;

export function getGoodsTypeTree(){
  return Vue.http.get(api + 'goods/goods_type/tree')
}

export function saveGoodsTypes(goodsTypeList){
  return Vue.http.post(api + 'goods/goods_type/save', goodsTypeList)
}

export function getProductTree(){
  return Vue.http.get(api + 'goods/product/tree')
}



// WEBPACK FOOTER //
// ./src/api/goods_type.js